import { mapState } from "vuex";
import Agreement from "@/components/Agreement";

let self = {};

export default {
  components: {
    Agreement,
  },
  data() {
    return {
      loading: true,
      loadText: "加载中",
      env: process.env,
      orgId: "",
      shopActive: 0,
      shopId: "",
      shopInfo: {
        qualificationStatus: 3,
      },
      ruleForm: {
        name: "",
        tel: "",
        areaId: "",
        areaAxis: "",
        addr: "",
        shopQualification: [],
        businesScope: "", // 二级分类名称字符串，以逗号分割
        shopBusinessType: "", // 一级分类id的和
        shopCatestr: [], // 分类字符串，"[{"axis":"$二级分类$三级分类","firstcateName":"二级分类名称"}]"
        boIdServicePersonalName: "",
      },
      servicePer: false,
      area: {
        lazy: true,
        lazyLoad(node, resolve) {
          const { level, value = 0 } = node;
          setTimeout(() => {
            self.$store
              .dispatch("app/getAreas", {
                parentId: value,
              })
              .then((data) => {
                const nodes = [];
                data.forEach(function (item) {
                  if (item.end) {
                    const map = {
                      value: String(item.id),
                      label: String(item.name),
                      leaf: level >= 2,
                    };
                    nodes.push(map);
                  } else {
                    const map = {
                      value: String(item.id),
                      label: String(item.name),
                      leaf: level >= 3,
                    };
                    nodes.push(map);
                  }
                });
                // 通过调用resolve将子节点数据返回，通知组件数据加载完成
                resolve(nodes);
              });
          }, 1000);
        },
      },
      rules: {
        tel: [
          { required: true, message: "请输入联系方式", trigger: "blur" },
          { min: 11, max: 11, message: "请输入正确的联系方式", trigger: "blur" },
        ],
        name: [{ required: true, message: "请输入店铺名称", trigger: "blur" }],
        addr: [{ required: true, message: "请输入详细收货地址", trigger: "blur" }],
        areaId: [{ required: true, message: "请选择收货地址", trigger: "blur" }],
      },
      error: {
        bus: "",
        img: "",
      },
      areaValue: [],
      photoList: [],

      busList: [], // 选中的经营类目
      busTypeTree: [], // 经营类目选项
      props: {
        value: "id",
        label: "name",
        children: "childCategoryList",
        multiple: true,
      },

      orgMembersList: [], // 服务人员列表
      checked: false,
      conChecked: false, //合同
      agreementVisible: false,
    };
  },

  computed: {
    ...mapState({
      enterprise: (state) => state["shop/shop"].enterprise,
    }),
  },

  created() {
    console.log("enterprise", this.enterprise);
    this.orgId = this.enterprise.default.ID;
    this.orgStatus = this.enterprise.default.state;
    this.getShopInfo();
  },

  mounted() {
    self = this;
  },

  methods: {
    // 获取店铺信息
    getShopInfo() {
      this.loadText = "加载中";
      this.$store.dispatch("setUp/getShopInfo").then((data) => {
        this.loading = false;
        console.log("获取店铺信息", data);
        if (data) {
          this.shopInfo = data;
          const {
            name,
            tel,
            areaId,
            areaAxis,
            addr,
            boIdServicePersonalName,
            shopId,
            qualificationStatus,
            axisArr,
            shopServiceAmount,
            shopDeposit,
            isDepositPaid,
            shopQualification,
          } = data;
          const totalAmount = Number(shopServiceAmount) + Number(shopDeposit);
          this.shopInfo.totalAmount = totalAmount;
          this.shopId = shopId;
          this.shopActive = qualificationStatus === 1 ? 2 : 1;
          if (isDepositPaid === 1) {
            this.shopActive = 3;
          }
          if (shopQualification && shopQualification.length) {
            this.photoList = shopQualification.map((item) => {
              return {
                name: "",
                url: item,
              };
            });
          }
          this.areaValue = areaAxis.replace("$", "").split("$");
          const _busList = axisArr.map((item) => {
            const idList = item.split("$");
            return {
              secondAxis: `$${idList[1]}`,
              threeId: idList[2],
            };
          });
          if (qualificationStatus !== 1) {
            this.getbusTypeTree(_busList);
          }

          this.ruleForm = {
            ...this.ruleForm,
            name,
            tel,
            areaId,
            areaAxis,
            addr,
            boIdServicePersonalName,
          };
        } else {
          this.shopActive = 0;
          this.getbusTypeTree();
        }
      });
    },
    // 获取店铺业务类型
    getbusTypeTree(list) {
      this.$store
        .dispatch("setUp/getbusTypeTree", {
          shopId: "",
        })
        .then((data) => {
          console.log("data", data);
          this.busTypeTree = data || [];
          if (list) {
            let childCategoryList = [];
            this.busTypeTree.forEach((item) => {
              if (item.childCategoryList && item.childCategoryList) {
                childCategoryList = [...childCategoryList, ...item.childCategoryList];
              }
            });
            childCategoryList.forEach((item) => {
              list.forEach((item1) => {
                if (item1.secondAxis === item.axis) {
                  item1.firstId = item.pId;
                  item1.secondId = item.id;
                }
              });
            });
            this.busList = list.map((item) => {
              return [item.firstId, item.secondId, item.threeId];
            });
          }
        });
    },
    // 查询服务人员列表
    getOrgMembersList() {
      this.$store.dispatch("setUp/getOrgMembersList").then((data) => {
        console.log("服务人员列表", data);
        this.orgMembersList = data || [];
      });
    },

    resetForm() {
      console.log("点击取消");
      this.toTrade();
      // /orderSystem/shopCheck
    },

    submitForm() {
      const { checked, shopId, ruleForm, busList, photoList, busTypeTree } = this;
      if (!photoList.length) {
        this.error.img = "请上传经营资质";
        return;
      }
      this.error.img = "";
      if (!busList.length) {
        this.error.bus = "请选择经营类型";
        return;
      }
      this.error.bus = "";
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (!checked) {
            this.$message.warning("请先已阅读并同意《农信平台用户协议》");
            return;
          }
          let busFirstIds = [];
          const busTwoIds = [];
          const shopCatestr = [];
          busList.forEach((item) => {
            busFirstIds.push(item[0]);
            busTwoIds.push(item[1]);
            const axis = `$${item[1].split("_")[1]}$${item[2]}`;
            shopCatestr.push({
              axis,
              firstcateName: "",
            });
          });
          busFirstIds = Array.from(new Set(busFirstIds));
          let childCategoryList = [];
          busTypeTree.forEach((item) => {
            if (item.childCategoryList && item.childCategoryList.length) {
              childCategoryList = [...childCategoryList, ...item.childCategoryList];
            }
          });
          const businesScopeList = [];
          childCategoryList.forEach((item) => {
            if (
              busTwoIds.find((id) => {
                return item.id === id;
              })
            ) {
              businesScopeList.push(item.name);
            }
            shopCatestr.forEach((item1, index) => {
              const axis = `$${item1.axis.split("$")[1]}`;
              if (axis === item.axis) {
                shopCatestr[index].firstcateName = item.name;
              }
            });
          });
          const shopQualification = photoList.map((item) => {
            return item.url;
          });
          console.log("busFirstIds", busFirstIds);
          const shopBusinessType = busFirstIds.length > 1 ? busFirstIds.reduce((prev, next) => Number(prev) + Number(next)) : busFirstIds[0];
          this.ruleForm = {
            ...ruleForm,
            businesScope: businesScopeList.toString(),
            shopBusinessType,
            shopCatestr: JSON.stringify(shopCatestr),
            shopQualification,
          };
          if (shopId) {
            this.ruleForm.shopId = shopId;
          }
          console.log("ruleForm", this.ruleForm);
          this.loadText = "审核提交中";
          this.loading = true;
          this.$store.dispatch("setUp/saveShopInfo", this.ruleForm).then((res) => {
            this.loading = false;
            this.loadText = "加载中";
            if (res.code === "0") {
              // 您的开店申请已提交成功，请耐心等待审核结果
              this.$alert("您的开店申请已提交成功，请耐心等待审核结果", "提示", {
                confirmButtonText: "确定",
                callback: () => {
                  this.toTrade();
                },
              });
              // this.$message.success("审核提交成功！");
              // setTimeout(() => {
              //   this.loading = true;
              //   this.getShopInfo();
              // }, 1500);
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    areaChange(value = []) {
      const areaId = value[value.length - 1];
      this.ruleForm = {
        ...this.ruleForm,
        areaId,
        areaAxis: `$${value.join("$")}`,
      };
    },
    // 上传图片之前
    uploadBefore(file) {
      const { size, type } = file;
      const isVerify = /(jpg|bmp|jpeg|png)$/.test(type);
      const isLt3M = size / 1024 / 1024 < 50;

      if (!isVerify) {
        this.$message.error("上传必须是JPG/BMP/JPEG/PNG/格式");
      } else if (!isLt3M) {
        this.$message.error("上传大小不能超过 50MB");
      }
      return isVerify && isLt3M;
    },
    // 上传图片成功之后
    uploadSuccess(res) {
      console.log("上传图片成功之后", res);
      const {
        data: { name, url },
      } = res;
      const item = {
        name: name || "",
        url: url || "",
      };
      this.photoList.push(item);
    },
    // 删除图片
    uploadRemove(file, fileList) {
      this.photoList = fileList;
    },

    toPay() {
      const { env, conChecked } = this;
      const { shopId, contractId, contractSignStatus } = this.shopInfo;
      if (contractSignStatus === 0) {
        this.$message.warning("请签署合同后进行支付");
        return;
      }
      if (!conChecked) {
        this.$message.warning("请您知晓并已确认合同内容");
        return;
      }
      this.$store
        .dispatch("setUp/confirmTheContract", {
          contractId,
          status: 1,
          shopId,
        })
        .then((res) => {
          console.log("确认合同返回值", res);
        });
      const url = `${env.VUE_APP_APP}payment/chectout/shopCheckout/${shopId}`;
      window.top.postMessage({ fn: "open", data: { url, title: "收银台", target: 0 } }, "*");
      this.$confirm("请确认您是否完成了支付", "支付确认", {
        confirmButtonText: "我已支付",
        cancelButtonText: "支付遇到问题",
        closeOnClickModal: false,
        center: true,
      })
        .then(() => {
          this.loading = true;
          this.getShopInfo();
        })
        .catch(() => {
          this.loading = true;
          this.getShopInfo();
        });
    },
    signContract() {
      const { env, shopInfo } = this;
      const url = `${env.VUE_APP_HOME}innerApps/contract/${shopInfo.contractNumericalOrder}`;
      const title = shopInfo.contractSignStatus === 0 ? "签署合同" : "查看合同";

      window.parent.postMessage({ fn: "open", data: { url, title, target: 0 } }, "*");
      if (shopInfo.contractSignStatus === 0) {
        this.$confirm("请确认您是否签署了对应合同", "合同签署", {
          confirmButtonText: "签署完成",
          cancelButtonText: "未签署",
          closeOnClickModal: false,
          center: true,
        })
          .then(() => {
            this.loading = true;
            this.getShopInfo();
          })
          .catch(() => {
            this.loading = true;
            this.getShopInfo();
          });
      }
    },
    toTrade() {
      window.top.location = `${this.env.VUE_APP_HOME}trade/default`;
    },

    orgAut() {
      const { env, orgId } = this;
      window.parent.postMessage({ fn: "open", data: { url: `${env.VUE_APP_WO}ent/authentication/${orgId}`, title: "企业认证", target: 1 } }, "*");
    },
    toBalance() {
      // https://jr.nxin.com/v/accountAsset/balance?sysSource=home
      const { env } = this;

      window.parent.postMessage({ fn: "open", data: { url: `${env.VUE_APP_JR}v/accountAsset/balance?sysSource=home`, title: "余额充值", target: 0 } }, "*");
    },
    pdfLink() {
      const url = "https://cmscenter-files.nxin.com/nxsc/%E9%99%84%E4%BB%B6%E4%B8%8A%E4%BC%A0%E8%AF%B4%E6%98%8E.pdf";
      window.open(url, "_blank");
    },
  },
};
